import React from "react";
import "./Icons.scss";
const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon-arrow-down"
      viewBox="0 0 23.48 22.99"
    >
      <g data-name="Spare to ignore">
        <polyline
          className="cls-1"
          points="18.9 13.05 12.05 19.89 4.81 12.65"
        />
        <line className="cls-1" x1="11.99" y1="2.73" x2="11.99" y2="18.87" />
      </g>
    </svg>
  );
};

export default ArrowRight;
